import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import TextField from '@mui/material/TextField';
import AutoComplete, { createFilterOptions } from '@mui/material/Autocomplete';
import DatePicker from "react-datepicker";
import {Box, ThemeProvider } from '@mui/material';
import "react-datepicker/dist/react-datepicker.css";
import {baseUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

const GrnEntry = (props) => {
  const [consData, setConsData] = useState([]);
  const [items, setItems] = useState([]);
  const [rows, setRows] = useState([{id:'', hsn: '', product: '', pack: '', fqty: '', totqty: '', pprice: '', mrp: '', disc: '',
            sgst: '', cgst: '', batch: '', expiry: ''}]);
  const [total, setTotal] = useState(0);
  const [subtotal, setSubTotal] = useState(0);
  const currentDate = new Date();
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedDate1, setSelectedDate1] = useState(new Date());
  const currentYear = new Date().getFullYear() % 100;
  const [expiryDate, setExpiryDate] = useState(new Date());
  
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [pharmData,setpharmData]=useState({
        dist: '',
        grn_no: '',
        product: '',
        pack: '',
        qty: '',
        fqty: '',
        totqty: '',
        mrp: '',
        pprice: '',
        disc: '',
        sgst: '',
        cgst: '',
        netamount: '',
        gstamount: '',
        batch: '',
        expiry: '',
        type: '',
        grnamount: '',
        invamount: '',
        grn_date: '',
        inv_date: '',
        invoice: '',
        status:'',
        addedby:'',
        ip_add:'',
     });
function debounce(func, delay) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(this, args), delay);
    };
  }
  useEffect(() => {
    fetchPharmDataDebounced();
    fetchConsData();
          const intervalId = setInterval(fetchPharmData, 30000);
      return () => clearInterval(intervalId);
  }, []);

     function fetchPharmData(page = 1, pageSize = 10) {
      const totqtyParam = 'gt0';  // Adjust filter parameter as needed
      const queryParams = `totqty=${totqtyParam}&page=${page}&page_size=${pageSize}`;

      axios.get(`${baseUrl}pharm-search/?${queryParams}`)
        .then((pharmResponse) => {
          setItems(pharmResponse.data);
        })
        .catch(error => {
          console.log(error);
        });
    }
  const fetchPharmDataDebounced = debounce(fetchPharmData, 500);  // 500ms delay
  function fetchConsData() {
    axios.get(`${baseUrl}add-distributor/`)
      .then((consResponse) => {
        setConsData(consResponse.data);
      })
      .catch(error => {
        console.log(error);
      });
  }
  const handleDateChange = (date) => {
    if (date) {
        setSelectedDate(date);
    }
};

const handleDateChange1 = (date) => {
    if (date) {
        setSelectedDate1(date);
    }
};

 const handleConsChange = (event) => {
  const selectedValue = event.target.value;
  setpharmData(prevState => ({ ...prevState, dist: selectedValue }));
};

const formatDate1 = (date) => {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
};

  const handleKeyDown = (e, index) => {
      const newRows = [...rows];
      switch (e.keyCode) {
        // Handle Shift key
        case 16:
          e.preventDefault();
            if (index === rows.length - 1) {
              newRows.push({ hsn: '', product: '', pack: '', fqty: '', totqty: '', pprice: '', mrp: '', disc: '',
                    sgst: '', cgst: '', batch: '', expiry: '' });
            }
          break;
        // Handle arrow up key
        case 18:
          e.preventDefault();
            newRows.splice(index, 1);
          break;
        case 38:
          e.preventDefault();
          if (newRows[index].selectedItem === 0) {
            newRows[index].selectedItem = items.length - 1;
          } else {
            newRows[index].selectedItem--;
          }
          setRows(newRows);
          break;
        // Handle arrow down key
        case 40:
          e.preventDefault();
          if (newRows[index].selectedItem === items.length - 1) {
            newRows[index].selectedItem = 0;
          } else {
            newRows[index].selectedItem++;
          }
          setRows(newRows);
          break;
        default:
          break;
      }
      setRows(newRows);
    };

const handleSelect = (val, index, id) => {
  const selectedId = id && id.id ? id.id : 0; // Set selectedId to 0 if id is not found
  const selectedItem = val;

  if (!selectedItem) {
    console.log('Selected item not found');
    return;
  }

  const newRows = [...rows];
  // Check if the selected ID already exists in the rows
  const existingRowIndex = newRows.findIndex(row => row.id === selectedItem.id);

  const pack = selectedItem.pack || 1; // Default to 1 if pack is not available
  const qty = selectedItem.qty || 1;   // Default qty to 1 if not provided
  const pprice = selectedItem.pprice || 0;
  const disc = selectedItem.disc || 0;
  const sgst = selectedItem.sgst || 0;
  const cgst = selectedItem.cgst || 0;

  // Calculate netamount based on selectedItem values (same logic as handleAmountChange)
  const net = pprice * qty;
  const disc1 = disc / 100;
  const disca = net * disc1;
  const dism = net - disca;
  const gst = parseFloat(sgst) + parseFloat(cgst);
  const tax1 = (gst / 100) * dism;
  const netamount = dism + tax1; // This will replace using MRP for netamount

  if (existingRowIndex !== -1) {
    // Update the existing row
    newRows[existingRowIndex].qty += 1;
    newRows[existingRowIndex].totqty = newRows[existingRowIndex].pack * newRows[existingRowIndex].qty;
    newRows[existingRowIndex].netamount = netamount; // Updated calculation
  } else {
    // Add a new row
    newRows[index] = {
      id: selectedItem.id,
      hsn: selectedItem.hsn,
      product: selectedItem.product,
      pack: pack,
      disc: disc,
      sgst: sgst,
      cgst: cgst,
      qty: qty,
      totqty: qty * pack,
      mrp: selectedItem.mrp,
      pprice: pprice,
      fqty: 0,
      netamount: netamount, // Updated calculation instead of using MRP
      batch: selectedItem.batch,
      gstamount: tax1, // Added GST amount field
    };
  }

  setRows(newRows);
};

const handleAmountChange = (e, index) => {
  const newRows = [...rows];
  const { name, value } = e.target;

  newRows[index] = {
    ...newRows[index],
    [name]: parseFloat(value) || 0
  };

  const { pack, qty, pprice, mrp, disc, fqty, sgst, cgst } = newRows[index];

  newRows[index].totqty = pack * qty;
  const net = pprice * qty;
  const disc1 = disc / 100;
  const disca = net * disc1;
  const dism = net - disca;
  const gst = parseFloat(sgst) + parseFloat(cgst);
  const tax1 = (gst / 100) * dism;
  newRows[index].netamount = (dism + tax1);
  newRows[index].gstamount = tax1;
  setRows(newRows);
};


  const handleAddRow = () => {
    const newRows = [...rows];
    newRows.push({id:'', hsn: '', product: '', pack: '', fqty: '', totqty: '', pprice: '', mrp: '', disc: '',
            sgst: '', cgst: '', batch: '', expiry: ''});
    setRows(newRows);
  };

  const inputRefs = useRef([]);
  useEffect(() => {
      inputRefs.current[inputRefs.current.length - 1]?.focus();
  }, [rows.length]);

  const handleDeleteRow = (index) => {
    const newRows = [...rows];
    newRows.splice(index, 1);
    setRows(newRows);
    inputRefs.current.splice(index, 1);
  };


  useEffect(() => {
    let subtotal = 0;
    let newTotal = 0;
    for (let i = 0; i < rows.length; i++) {
      const row = rows[i];
      subtotal += parseFloat(row.netamount) || 0;
      newTotal = subtotal;
    }
    setSubTotal(subtotal);
  }, [rows]);

  const handleChange = (e, index) => {
    const { name, value } = e.target;
         const intValue = parseInt(value, 10);
      if (name == 'exp_mn') {
            const monthValue = parseInt(value, 10);
            if (monthValue < 1 || monthValue > 12) {
                return; // Ignore invalid month values
            }
        }

    if (name === 'exp_yr') {
        if (value.length === 2 && intValue < currentYear) {
            alert(`Please enter a valid year (${currentYear} or higher).`);
            return;
        }
    }
    const updatedRows = [...rows];
    updatedRows[index] = {
        ...updatedRows[index],
        [name]: value
    };
    const expMn = updatedRows[index].exp_mn;
    const expYr = updatedRows[index].exp_yr;

    if (expMn && expYr && expMn >= 1 && expMn <= 12 && expYr >= currentYear) {
      const fullYear = 2000 + parseInt(expYr, 10);
      const month = parseInt(expMn, 10);
  
      const lastDay = new Date(fullYear, month, 0).getDate();
      const formattedMonth = month.toString().padStart(2, '0');
  
      updatedRows[index].expiryDate = `${lastDay}-${formattedMonth}-${fullYear}`;
  }

    // Update the state
    setRows(updatedRows);
    setpharmData(prevState => ({ ...prevState, [name]: value }));
};

const formatDate = (dateStr) => {
  const date = new Date(dateStr);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

const formSubmit = async (e) => {
  e.preventDefault();
   setIsSubmitting(true);
  const dbType = document.getElementById('dbType').value;
  if (!pharmData.dist) {
    Swal.fire('Error', 'Please select a Distributor.', 'error');
      setIsSubmitting(false);
    return;
  }

  const tolerance = 1; // Define your tolerance level here
  if (Math.abs(parseFloat(pharmData.invAmount) - parseFloat(subtotal)) > tolerance) {
    Swal.fire('Error', 'Invoice and GRN amount are mismatching.', 'error');
      setIsSubmitting(false);
    return;
  }

    const expiryDates = rows.map(row => row.expiryDate || '').join(',');
  const idsFromRows = rows.map(row => row.id || 0);
  const eqtys = rows.map(row => row.totqty);
  const expiryMap = {};
  const totqtyMap = {};
  const totqtyMap1 = {};
    const hsnMap = {};
  eqtys.forEach((totqty, index) => {
    const id = idsFromRows[index];
    const item = items.find(item => item.id == id);
    const rowTotqty = totqty;
    const itemTotqty = item ? item.totqty : 0;
    const fqty = rows[index].fqty || 0;
    totqtyMap[id] = rowTotqty + fqty;
    totqtyMap1[id] = itemTotqty;
    expiryMap[id] = rows[index].expiryDate || ''; // Use the calculated expiryDate
    hsnMap[id] = rows[index].hsn || ''; // Map hsn here
  });

  const allIds = idsFromRows.join(',');

  try {
    const grnResponse = await axios.post(`${baseUrl}get_grn_no/`);
    const grn_id = grnResponse.data.value;

    // Update all existing products first
    const updatePromises = allIds.split(',').map((id, index) => {
      if (id !== '0') {
        const phData = {
          totqty: totqtyMap1[id],
          expiry: expiryMap[id],
          hsn: hsnMap[id],
          dist: pharmData.dist,
          ip_add: ipAddress,
        };

        return axios.put(`${baseUrl}update-pharm-qty/${id}/`, phData)
          .then(() => {
            // After successful update, update indent use
            const indentPharmData = {
              did: id,
              qty: totqtyMap[id],
              ip_add: ipAddress,
            };

            return axios.post(`${baseUrl}update-indent-grn-add/`, indentPharmData);
          });
      } else {
        return Promise.resolve(); // Skip new products for now
      }
    });

    await Promise.all(updatePromises); // Wait for all updates to finish

    // Proceed with GRN creation only if all updates are successful
    const _formData = new FormData();
    _formData.append('grn_no', grn_id);
    _formData.append('dist', pharmData.dist);
    _formData.append('id', rows.map(row => row.id).join(','));
    _formData.append('hsn', rows.map(row => row.hsn).join(','));
    _formData.append('product', rows.map(row => row.product).join(','));
    _formData.append('pack', rows.map(row => row.pack).join(','));
    _formData.append('qty', rows.map(row => row.qty).join(','));
    _formData.append('fqty', rows.map(row => row.fqty).join(','));
    _formData.append('totqty', rows.map(row => row.totqty).join(','));
    _formData.append('mrp', rows.map(row => row.mrp).join(','));
    _formData.append('pprice', rows.map(row => row.pprice).join(','));
    _formData.append('disc', rows.map(row => row.disc).join(','));
    _formData.append('sgst', rows.map(row => row.sgst).join(','));
    _formData.append('cgst', rows.map(row => row.cgst).join(','));
    _formData.append('netamount', rows.map(row => Number(row.netamount).toFixed(2)).join(','));
    _formData.append('gstamount', rows.map(row => Number(row.gstamount).toFixed(2)).join(','));
    _formData.append('batch', rows.map(row => row.batch).join(','));
    _formData.append('expiry', expiryDates);
    _formData.append('grn_date', formatDate1(selectedDate));
    _formData.append('inv_date', formatDate1(selectedDate1));
    _formData.append('grnamount', subtotal.toFixed(2));
    _formData.append('invamount', pharmData.invAmount);
    _formData.append('type', dbType);
    _formData.append('invoice', pharmData.invoice);
    _formData.append('status', '1');
    _formData.append('pay_status', '0');
    _formData.append('addedby', userName);
    _formData.append('ip_add', ipAddress);
    _formData.append('location', userLocation);

    const grnCreationResponse = await axios.post(`${baseUrl}add-grn/`, _formData);

    if (grnCreationResponse.status === 200 || grnCreationResponse.status === 201) {
      // Handle new products
      const newProductPromises = rows.map(row => {
        if (row.id === '0') {
          const formData = new FormData();
          const unet = parseFloat(row.mrp / row.pack);
          formData.append('dist', pharmData.dist);
          formData.append('hsn', row.hsn);
          formData.append('product', row.product);
          formData.append('pack', row.pack);
          formData.append('qty', row.qty);
          formData.append('fqty', row.fqty);
          formData.append('totqty', 0);
          formData.append('mrp', row.mrp);
          formData.append('pprice', row.pprice);
          formData.append('sprice', row.mrp);
          formData.append('disc', row.disc);
          formData.append('sgst', row.sgst);
          formData.append('cgst', row.cgst);
          formData.append('netamount', row.netamount.toFixed(2));
          formData.append('gstamount', row.gstamount.toFixed(2));
          formData.append('uamount', unet.toFixed(2));
          formData.append('batch', row.batch);
          formData.append('expiry', formatDate(row.expiry));
          formData.append('status', '1');
          formData.append('addedby', userName);
          formData.append('ip_add', ipAddress);
          formData.append('location', userLocation);

          return axios.post(`${baseUrl}add-pharm/`, formData);
        }
      });

      await Promise.all(newProductPromises);

      Swal.fire({
        title: 'Pharmacy Bill Generated.',
        icon: 'success',
        timer: 5000,
        showConfirmButton: false
      });

      setTimeout(() => {
        window.location.href = '/pharm-store/';
      }, 3000);
    }
  } catch (error) {
    console.log(error);
    Swal.fire('Error!', 'Failed to complete the process. Please try again later.', 'error');
    setIsSubmitting(false);
  }
};

const customFilterOptions = (options, state) => {
  const inputValue = state.inputValue.toLowerCase().trim();

  // Start filtering only after 3 characters
  if (inputValue.length < 3) {
    return [];
  }

  const filteredOptions = options.filter(option => {
    const label = (option.product || '').toLowerCase();

    // Match input anywhere in the label
    return label.startsWith(inputValue);
  });

  // Sort results: prioritize startsWith matches, then alphabetically
  const sortedOptions = filteredOptions.sort((a, b) => {
    const labelA = (a.product || '').toLowerCase();
    const labelB = (b.product || '').toLowerCase();

    const startsWithA = labelA.startsWith(inputValue);
    const startsWithB = labelB.startsWith(inputValue);

    if (startsWithA && !startsWithB) return -1;
    if (!startsWithA && startsWithB) return 1;

    return labelA.localeCompare(labelB); // Sort alphabetically if equal
  });

  return sortedOptions;
};


  return (
  <section className="container mt-4">
  <form>
        <div className="row">
        <div className='col-md-6 mb-2'>
            <label>Distributor:</label>
            <select name="dist" id="dist"  onChange={handleConsChange} className="form-control">
                <option> Select Distributor </option>
                {consData.map((category, index) => (
                <option key={index} value={category.id}>
                  {category.name}
                </option>
              ))}
            </select>
        </div>
        <div className='col-md-6 mb-2'>
            <label>GRN Date:</label>
            <DatePicker selected={selectedDate || new Date()} onChange={handleDateChange} dateFormat="yyyy-MM-dd" readOnly/>
        </div>
        </div>
        <div className="row">
        <div className='col-md-6 mb-2'>
              <label>Purchase Type : </label>
              <select name="dbType" id="dbType" className="form-control" value={pharmData.ptype}>
                <option value="CreditPurchase">Credit Purchase</option>
                <option value="CashPurchase">Cash Purchase</option>
              </select>
        </div>
        <div className='col-md-6 mb-2'>
            <label>Invoice Date:</label>
            
            <DatePicker selected={selectedDate1 || new Date()} onChange={handleDateChange1} dateFormat="yyyy-MM-dd" />
        </div>
        </div>
        <div className="row">
        <div className='col-md-6 mb-2'>
            <label>GRN Amount:</label>
            <input type="number" className="form-control" name="grnAmount" id="grnAmount" placeholder="Grn Amount"
                value={parseFloat(subtotal).toFixed(2)} readOnly/>
        </div>
        <div className='col-md-6 mb-2'>
            <label>Invoice Amount:</label>
            <input type="number" className="form-control" name="invAmount" id="invAmount" onChange={handleChange} placeholder="Invoice Amount"
                value={pharmData.invAmount}/>
        </div>
        </div>
        <div className="row">
        <div className='col-md-6 mb-2'>
            <label>Invoice Number:</label>
            <input type="text" className="form-control" name="invoice" id="invoice" onChange={handleChange} placeholder="Invoice No"
                value={pharmData.invoice}/>
        </div>
        </div>
    <div className='form-control col-md-12 col-12 mb-5 table-responsive'>
      <table className="table table-bordered " style={{backgroundColor: '#1bc5ce', borderColor: 'pink', width: '100%'}}>
        <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th style={{width: 120}}>HSN</th>
          <th style={{width: 370}}>Drug Name</th>
          <th style={{width: 90}} >Pack</th>
          <th style={{width: 120}} >Qty</th>
          <th style={{width: 80}} >F.Qty</th>
          <th style={{width: 90}} >TotQty</th>
          <th style={{width: 120}} >PPrice</th>
          <th style={{width: 120}} >Mrp</th>
          <th style={{width: 110}} >Disc %</th>
          <th style={{width: 110}} >SGST %</th>
          <th style={{width: 110}} >CGST %</th>
          <th style={{width: 120}}>Net Amount<br />(Incl.GST)</th>
          <th style={{width: 120}}>Batch</th>
          <th style={{width: 80}}>Expiry</th>
          <th style={{width: 80}}>Action</th>

        </tr>
      </thead>
      <tbody>
      {rows.map((row, index) => (
        <tr key={index}>
        <td>
            <input
              type="text"
              name="id"

              value={row.id || 0}
              onChange={e => handleChange(e, index)}
              style={{width: 80, display: 'none'}}
              tabIndex={-1}
              readOnly
            />
            <input
              type="text"
              name="hsn"

              value={row.hsn}
              onChange={e => handleChange(e, index)}
              style={{width: 80}}
              tabIndex={-1}
            />
            </td>
            <td>
            <AutoComplete
          items={items}
          options={items}
          sx={{ width: 200 }}
          componentsProps={{
            paper: {
              sx: {
                width: 800
              }
            }
          }}
          fullWidth
          onKeyDown={e => handleKeyDown(e, index)}
          onChange={(event, val, id) => handleSelect(val, index, id)}
          getOptionLabel={(option) => option.product ? option.product : ''}

           renderOption={(props, option) => (
              <Box component="li" {...props}
              
              sx={{
              width: 750,
              height: 50,
              borderRadius: 1,
                }}
              >
                {option.product ? `${option.product} ID: ${option.id} Expy: (${option.expiry}) MRP: (${option.mrp}) Batch: ${option.batch}
                TQty: ${option.totqty} ` : ''}
              </Box>

            )}
           renderInput={(params) => (
            <div ref={params.InputProps.ref}>
            <input className="form-control" type="text" {...params.inputProps}  autoFocus
               style={{
                  background: "#F7EEFF",
                  }}
             />
            </div>
           )}
            ref={(el) => inputRefs.current[index] = el}
            filterOptions={customFilterOptions}
           />
           </td>
           <td>
            <input
              type="number"
              className="ms-2 me-1"
              name="pack"
              style={{width: 60}}
              value={row.pack}
              onChange={(e) => {
                handleChange(e);
                handleAmountChange(e, index);
              }}
              tabIndex={0}
            />
            </td>
           <td>
            <input
              type="number"
              style={{ width: 70 }}
              className="ms-2 me-1"
              value={row.qty}
              name="qty"
              onChange={(e) => {
                handleChange(e, index);
                handleAmountChange(e, index);
              }}
              onKeyDown={(e) => handleKeyDown(e, index)}
              tabIndex={0}
              required
            />
            </td>
           <td>
            <input
              type="number"
              style={{ width: 60 }}
              className="ms-2 me-1"
              value={row.fqty}
              name="fqty"
              onChange={(e) => {
                handleChange(e, index);
                handleAmountChange(e, index);
              }}
              onKeyDown={(e) => handleKeyDown(e, index)}
              tabIndex={0}
              required
            />
            </td>
           <td>
            <input
              type="number"
              className="ms-2 me-1"
              style={{width: 70}}
              name="totqty"
              value={row.totqty}
              onChange={(e) => {
                handleChange(e, index);
                handleAmountChange(e, index);
              }}
              tabIndex={-1}
              readOnly
            />
            </td>
           <td>
            <input
              type="number"
              className="ms-2 me-1"
              style={{width: 90}}
              name="pprice"
              value={row.pprice}
              onChange={(e) => {
                handleChange(e, index);
                handleAmountChange(e, index);
              }}
              onKeyDown={(e) => handleKeyDown(e, index)}
              tabIndex={0}
            />
            </td>
           <td>
            <input
              type="number"
              className="ms-2 me-1"
              style={{width: 90}}
              name="mrp"
              value={row.mrp}
              onChange={(e) => {
                handleChange(e, index);
                handleAmountChange(e, index);
              }}
              onKeyDown={(e) => handleKeyDown(e, index)}
              tabIndex={0}
            />
            </td>
           <td>
            <input
              type="number"
              className="ms-2 me-1"
              style={{width: 50}}
              name="disc"
              value={row.disc || 0}
              onChange={(e) => {
                handleChange(e, index);
                handleAmountChange(e, index);
              }}
              onKeyDown={(e) => handleKeyDown(e, index)}
              tabIndex={0}
            />
            </td>
           <td>
            <input
              type="number"
              className="ms-2 me-1"
              style={{width: 60}}
              name="sgst"
              value={row.sgst}
              onChange={(e) => {
                handleChange(e, index);
                handleAmountChange(e, index);
              }}
              onKeyDown={(e) => handleKeyDown(e, index)}
              tabIndex={0}
            />
            </td>
           <td>
            <input
              type="number"
              className="ms-2 me-1"
              style={{width: 60}}
              name="cgst"
              value={row.cgst}
              onChange={(e) => {
                handleChange(e, index);
                handleAmountChange(e, index);
              }}
              onKeyDown={(e) => handleKeyDown(e, index)}
              tabIndex={0}
            />
            </td>
           <td>
            <input
              type="number"
              className="ms-2 me-1"
              style={{width: 90}}
              name="netamount"
              value={parseFloat(row.netamount).toFixed(2)}
              onChange={(e) => {
                handleChange(e, index);
                handleAmountChange(e, index);
              }}
              onKeyDown={(e) => handleKeyDown(e, index)}
              tabIndex={0}
              readOnly
            />

            <input
              type="text"
              className="ms-2 me-1"
              style={{width: 90, display: 'none'}}
              name="gstamount"
              value={row.gstamount}
              onChange={(e) => {
                handleChange(e, index);
                handleAmountChange(e, index);
              }}
              tabIndex={0}
            />
            </td>
           <td>
            <input
              type="text"
              className="ms-2 me-1"
              style={{width: 110, textTransform: 'uppercase' }}
              name="batch"
              value={row.batch}
              onChange={(e) => handleChange(e, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              tabIndex={0}
            />
            </td>
            <td>
                    <input
                        type="number"
                        name="exp_mn"
                        value={row.exp_mn || ''}
                        onChange={(e) => handleChange(e, index)}
                        className="form-control exp"
                        style={{ width: 100 }}
                        min="1"
                        max="12"
                        placeholder="MM"
                        required
                    />
                </td>
                <td>

                    <input
                        type="number"
                        name="exp_yr"
                        value={row.exp_yr}
                        onChange={(e) => handleChange(e, index)}
                        className="form-control exp"
                        style={{ width: 100 }}
                        min={new Date().getFullYear() % 100}
                        max="50"
                        placeholder="YY"
                        required
                    />
                </td>
           <td>
             <button className="btn btn-danger" type="button" onClick={() => handleDeleteRow(index)}>Delete</button>
        </td>
        </tr>
      ))}
        </tbody>
        </table>
      <button className="btn btn-success addmore mt-4" type="button" onClick={handleAddRow}>Add More</button>

<div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}
        className='mb-5' >
          <button type="button"  onClick={formSubmit} className="btn btn-primary mt-4">Submit</button>
</div>
    </div>
    </form>
  </section>
  );
};

export default GrnEntry;